module.exports = __webpack_public_path__ + "img/get-quote.7426ad7d.svg";